import React,{Component} from 'react';
import {  Route, Switch } from 'react-router-dom';
import { Container } from 'reactstrap';

import {
  AppFooter,
  AppHeader,
} from '@coreui/react';

import routes from '../../routes';
import * as actionCreator from "../../store/Action";
import {connect} from "react-redux";
import '../Reception/Style.css'

import DefaultFooter from './ReceptionFooter'
import DefaultHeader from './ReceptionHeader'
import Cookies from "js-cookie";

class DefaultLayout extends Component {

  loading = () =>  <span />;

  signOut(e) {
    e.preventDefault();
    Cookies.remove("68a6102f6ed24899420170004a0273b8");
    this.props.history.push('/login')
  }

  componentDidMount(){
    document.title = "Visitor Portal";
    this.props.callAllCount(this.props.usr_obj);
  }

  render() {
    return (
      <div className="app">
        <AppHeader fixed>

            <DefaultHeader onLogout={e=>this.signOut(e)}/>

        </AppHeader>
        <div className="app-body">
          <main className="main recept external-recept" style={{marginLeft:'0px!important'}}>

            <Container fluid>

                <Switch>
                  {routes.map((route, idx) => {
                    return route.component ? (
                      <Route
                        key={idx}
                        path={route.path}
                        exact={route.exact}
                        name={route.name}
                        render={props => (
                          <route.component route_name={route.name} {...props} />

                        )} />
                    ) : (null);
                  })}
                  {/*<Redirect from="/" to="/login" />*/}
                </Switch>

            </Container>
          </main>
          {/*<AppAside fixed>*/}

          {/*<DefaultAside />*/}

          {/*</AppAside>*/}
        </div>
        <AppFooter className={"footer-recept"}>

            <DefaultFooter />

        </AppFooter>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  is_spin: state.spinnerReducer.is_spin,
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {


    callAllBuildings : (data) => dispatch(actionCreator.callAllBuildings(data)), // Get All Buildings Of Corporate
    callAllWifiPackages : (data) => dispatch(actionCreator.callAllWifiPackages(data)), // Get All Wifi Packges Of Corporate
    callAllCount : (data) => dispatch(actionCreator.callAllCount(data)), // Get All counts

    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    //user data handler:
    userHandler: (data) => dispatch(actionCreator.userHandler(data)),
    // history reducer
    browserHistoryHandler: (data) => dispatch(actionCreator.browserHistoryHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DefaultLayout);
